/**
 *
 */
export class LoadError extends Error {
  /**
 *
 */
  name = "LoadError";

  /**
 *
 */
  status: number;

  /**
 *
 */
  response: Response;

  /**
 *
 *
 */
  errorContent?: string;

  constructor(message: string, response: Response, errorContent?: string | undefined) {
    const msg = response ? `${message}: ${response.status}, ${response.url}` : message;
    super(msg);

    /*                                                */
    this.status = response.status || 300;
    this.response = response;
    this.errorContent = errorContent;
  }
}
